<script>
  import ValidationMessage from '../../../../components/form/ValidationMessage.vue'
  import Password from 'vue-password-strength-meter'
  import * as restfulService from '../../../../services/restfulService'
  import DataService from '../../../../services/dataService'
  import helperMixin from '../../../../../mixins/helper'
  import bus from '@utils/bus'
  import {required} from 'vuelidate/lib/validators'
  import {cloneDeep} from 'lodash'

  export default {
    components: {ValidationMessage, Password},
    mixins: [helperMixin],
    props: ['registration'],
    data () {
      return {
        isLoadingData: true,
        isSubmitted: false,
        isSearchingInstitution: false,
        modalities: [],
        hasAppraisers: false,
        hasModalitiesSelected: false,
        hasSomeEvaluationTypeSelected: true,
        currentPrice: '0.00',
        evaluationTypes: [],
        evaluationTypesSelected: [],
        data: {
          event_id: '',
          literacy_id: '',
          literacy: {
            id: '',
            name: ''
          },
          institution_unit_id: '',
          institution: {
            id: '',
            name: ''
          },
          modalities: [],
          occupation_area: '',
          knowledge_area: [],
          knowledge_area_1_id: [],
          knowledge_area_2_id: [],
          knowledge_area_3_id: [],
          knowledge_area_4_id: [],
          amount: 0,
          minicurso: false
        },
        dependencies: {
          literacies: [],
          institutions: [],
          modalities: [],
          activities: [],
          knowledge_areas: [],
          knowledge_areas_level_1: [],
          knowledge_areas_level_2: [],
          knowledge_areas_level_3: [],
          knowledge_areas_level_4: []
        }
      }
    },
    validations: {
      data: {
        event_id: {required},
        literacy_id: {required},
        institution_unit_id: {required}
      }
    },
    mounted () {
      if (!this.registration) {
        this.$swal({
          title: 'Atenção',
          text: 'Você não pode acessar essa página diretamente',
          type: 'warning'
        })
        this.$router.push({name: 'registration.index'})
      } else {
        this.getDependencies()
        // Recupera os dados da props: registration e atribui ao data do componente
        this.data = {...this.data, ...this.registration.eventData.data}

        this.getEvaluationsType(this.data.event_id)

        // Caso o usuário possua o institution_unit_id se busca na API a instituição relacionada
        // e adiciona a mesma no array de instituições
        if (this.data.institution_unit_id) {
          this.getInstitution(this.data.institution_unit_id).then(response => {
            this.dependencies.institutions.splice(0)
            this.dependencies.institutions.push(response)
          })
        }

        // Caso o usuário possua o literacy_id dispara o evento onChangeLiteracy para mostrar as modalidades
        if (this.data.literacy_id) {
          this.onChangeLiteracy()
        }

        // Busca as áreas de conhecimento
        this.getKnowledgeAreas(null, 1).then(() => {
          if (this.data.knowledge_area.length === 0) {
            this.resetKnowledgeAreas()
          } else {
            if (this.data.knowledge_area_1_id.length > 0) {
              this.getKnowledgeAreas(this.data.knowledge_area_1_id, 2).then(() => {
                if (this.data.knowledge_area_2_id.length > 0) {
                  this.getKnowledgeAreas(this.data.knowledge_area_2_id, 3).then(() => {
                    if (this.data.knowledge_area_3_id.length > 0) {
                      this.getKnowledgeAreas(this.data.knowledge_area_3_id, 4)
                    }
                  })
                }
              })
            }
            setTimeout(() => {
              this.hasAppraisers = true
            }, 600)
          }
        })

        if (this.data.modalities.length > 0) {
          this.hasModalitiesSelected = true
        }

        this.isLoadingData = false
      }
    },
    methods: {
      /**
       * Buscas as dependencias na API
       * @returns {Promise<any>}
       */
      getDependencies () {
        return new Promise(resolve => {
          DataService.get([
            {domain: 'literacy'}
          ]).then((result) => {
            this.dependencies = {...this.dependencies, ...result}
            resolve()
          })
        })
      },
      /**
       * Busca avaliações de um evento
       * @param eventId
       */
      getEvaluationsType (eventId) {
        restfulService.get('event', 'evaluation-types', eventId)
          .then((response) => {
            this.evaluationTypes = response
          })
          .catch(e => {
            console.log(e)
          })
      },
      /**
       * Busca uma cidade na API/Segue
       * @param institutionId
       * @returns {Promise<any>}
       */
      getInstitution (institutionId) {
        return new Promise((resolve, reject) => {
          restfulService.get('institution', null, institutionId)
            .then((response) => {
              resolve(response)
            })
            .catch(e => {
              console.log(e)
              reject()
            })
        })
      },
      /**
       * Busca áreas de conhecimento na API
       * Cada level preenche uma lista de áreas de conhecimento diferente
       * 1: Grande Área, 2: Área, 3: Sub-área, 4: Especialidade
       *
       * @param knowledgeAreaId
       * @param level
       * @returns {Promise<any>}
       */
      getKnowledgeAreas (knowledgeAreaId, level) {
        return new Promise((resolve, reject) => {
          let searchData = {
            knowledge_area_id: null,
            orderBy: [
              {
                column: 'name',
                direction: 'ASC'
              }
            ]
          }
          if (knowledgeAreaId && knowledgeAreaId.length > 0) {
            searchData.knowledge_area_id = {in: knowledgeAreaId}
          }
          restfulService.search('knowledge_area', null, searchData, null, null, 1, 500)
            .then((response) => {
              if (level === 1) {
                this.dependencies.knowledge_areas_level_1.splice(0)
                this.dependencies.knowledge_areas_level_1 = [...this.dependencies.knowledge_areas_level_1, ...response.data]
              } else if (level === 2) {
                this.dependencies.knowledge_areas_level_2.splice(0)
                this.dependencies.knowledge_areas_level_2 = [...this.dependencies.knowledge_areas_level_2, ...response.data]
              } else if (level === 3) {
                this.dependencies.knowledge_areas_level_3.splice(0)
                this.dependencies.knowledge_areas_level_3 = [...this.dependencies.knowledge_areas_level_3, ...response.data]
              } else if (level === 4) {
                this.dependencies.knowledge_areas_level_4.splice(0)
                this.dependencies.knowledge_areas_level_4 = [...this.dependencies.knowledge_areas_level_4, ...response.data]
              }
              resolve()
            })
            .catch(e => {
              reject(e)
            })
        })
      },
      /**
       * Evento: Disparado quando se selecionam novas áreas de conhecimento
       */
      changeKnowledgeArea (knowledgeAreaId, level) {
        if (level === 2) {
          this.data.knowledge_area_2_id.splice(0)
          this.data.knowledge_area_3_id.splice(0)
          this.data.knowledge_area_4_id.splice(0)
        } else if (level === 3) {
          this.data.knowledge_area_3_id.splice(0)
          this.data.knowledge_area_4_id.splice(0)
        } else if (level === 4) {
          this.data.knowledge_area_4_id.splice(0)
        }
        knowledgeAreaId.forEach(item => {
          if (!this.data.knowledge_area.some(obj => obj === item)) {
            this.data.knowledge_area.push(item)
          }
        })
        this.getKnowledgeAreas(knowledgeAreaId, level)
      },
      /**
       * Evento: Disparado quando uma área de conhecimento é removida da lista
       */
      removeKnowledgeArea (knowledgeAreaId) {
        this.data.knowledge_area = this.data.knowledge_area.filter(item => item !== knowledgeAreaId)
      },
      /**
       * Reseta as informações das áreas de conhecimento
       */
      resetKnowledgeAreas () {
        this.data.knowledge_area.splice(0)
        this.data.knowledge_area_1_id.splice(0)
        this.data.knowledge_area_2_id.splice(0)
        this.data.knowledge_area_3_id.splice(0)
        this.data.knowledge_area_4_id.splice(0)
      },
      /**
       * Filtra as áreas de conhecimento selecionadas
       * @returns {Array}
       */
      getSelectedsKnowledgeAreas: function () {
        let knowledgeAreas = []
        if (this.data.knowledge_area && this.data.knowledge_area.length > 0) {
          this.data.knowledge_area.forEach(item => {
            let knowledgeArea = []
            knowledgeArea = this.dependencies.knowledge_areas_level_1.filter(obj => obj.id === item)
            if (!knowledgeArea.length) {
              knowledgeArea = this.dependencies.knowledge_areas_level_2.filter(obj => obj.id === item)
            }
            if (!knowledgeArea.length) {
              knowledgeArea = this.dependencies.knowledge_areas_level_3.filter(obj => obj.id === item)
            }
            if (!knowledgeArea.length) {
              knowledgeArea = this.dependencies.knowledge_areas_level_4.filter(obj => obj.id === item)
            }
            if (knowledgeArea.length) {
              knowledgeAreas.push(knowledgeArea[0])
            }
          })
          return knowledgeAreas.sort((a, b) => a.full_name > b.full_name)
        }
        return knowledgeAreas
      },
      /**
       * Busca instituições na API/Segue
       * @param query
       * @returns {Promise<any>}
       */
      onSearchInstitution (query) {
        if (query !== '') {
          this.isSearchingInstitution = true
          let data = {
            query
          }
          restfulService.post('institution', 'search', null, data)
            .then((response) => {
              this.dependencies.institutions.splice(0)
              this.dependencies.institutions = [...this.dependencies.institutions, ...response]
              this.isSearchingInstitution = false
            })
            .catch(e => {
              console.log(e)
            })
        }
      },
      /**
       * Evento: Disparado quando se altera a instituição
       */
      onChangeInstitution () {
        if (this.data.institution_unit_id) {
          this.onChangeLiteracy()
        } else {
          this.resetSelectedModalities()
        }
      },
      /**
       * Evento: Disparado quando se altera a escolaridade selecionada para carregar as modalidades disponíveis
       */
      onChangeLiteracy () {
        if (this.data.institution_unit_id && this.data.literacy_id) {
          bus.$emit('show-loader')
          let searchData = {
            event_id: this.data.event_id,
            institution_unit_id: this.data.institution_unit_id,
            literacy_id: this.data.literacy_id
          }
          this.dependencies.modalities.splice(0)
          if (this.data.literacy_id) {
            restfulService.post('event_modality', 'literacies', null, searchData)
              .then((response) => {
                this.dependencies.modalities = [...this.dependencies.modalities, ...response]
                response.forEach(item => {
                  if (item.children && item.children.length > 0) {
                    item.children.forEach(modality => {
                      if (!modality.not_charged) {
                        if (!modality.price && item.children && modality.children.length === 0) {
                          modality.disabled = true
                          modality.title = modality.title + ' - ' + 'Modalidade não disponível, contato o administrador'
                        } else {
                          if (!this.data.registration_id &&
                            modality.key === 'participante' &&
                            !this.data.modalities.some(eventModality => eventModality === modality.id)) {
                            this.data.modalities.push(modality.id)
                          }
                        }
                      } else {
                        modality.price = 0
                      }
                    })
                    this.hasModalitiesSelected = this.data.modalities.length > 0
                    this.setCurrentPrice()
                    setTimeout(() => {
                      if (this.$refs.modalities) {
                        this.hasAppraisers = (this.$refs.modalities.getCheckedNodes().some(item => item.key === 'avaliador'))
                        if (!this.hasAppraisers) {
                          this.resetKnowledgeAreas()
                        }
                      }
                    }, 300)
                    setTimeout(() => {
                      let cancelScroll = this.$scrollTo('#modalities', 500, {
                        onDone: function () {
                          cancelScroll()
                        }
                      })
                    }, 500)
                  }
                })
                if (this.data.registration_id) {
                  this.data.registration_id = null
                }
                bus.$emit('hide-loader')
              })
              .catch(e => {
                bus.$emit('hide-loader')
                console.log(e)
              })
          } else {
            this.resetSelectedModalities()
            bus.$emit('hide-loader')
          }
        } else {
          this.resetSelectedModalities()
          bus.$emit('hide-loader')
        }
      },
      /**
       * Evento que verifica mudanças na checagem das modalidades
       * Caso possua alguma modalidade do tipo avaliador, é atribuido true a variável hasAppraisers
       */
      onCheckModalities () {
        this.hasAppraisers = (this.$refs.modalities.getCheckedNodes().some(item => item.key === 'avaliador'))
        if (!this.hasAppraisers) {
          this.resetKnowledgeAreas()
        }
        this.hasModalitiesSelected = (this.$refs.modalities.getCheckedNodes().length > 0)
        this.onCheckEvaluationType()
        this.setCurrentPrice()
      },
      /**
       * Evento que verifica mudanças na checagem das modalidades
       * Caso possua alguma modalidade do tipo avaliador, é atribuido true a variável hasAppraisers
       */
      onCheckEvaluationType () {
        this.hasSomeEvaluationTypeSelected = true
        if (this.hasAppraisers) {
          this.hasSomeEvaluationTypeSelected = (this.$refs.modalities.getCheckedNodes().filter(item => item.key === 'avaliador').every(item => item.evaluation_types.length > 0))
        }
      },
      /**
       * Função pra limpar as modalidades selecionadas
       */
      resetSelectedModalities () {
        if (this.$refs.modalities) {
          this.$refs.modalities.setCheckedNodes([])
        }
        this.dependencies.modalities.splice(0)
        this.data.modalities.splice(0)
        this.hasModalitiesSelected = false
      },
      /**
       * Função que verifica as modalidades selecionadas e atribui o valor maior ao currentPrice
       */
      setCurrentPrice () {
        setTimeout(() => {
          let higherPrice = 0
          let hasModalities = false
          if (this.$refs.modalities) {
            this.$refs.modalities.getCheckedNodes().forEach(item => {
              hasModalities = true
              if (item.price && item.price >= higherPrice) {
                higherPrice = item.price
              }
            })
          } else {
            this.currentPrice = '0.00'
          }
          if (!hasModalities) {
            this.currentPrice = '0.00'
          } else {
            this.currentPrice = higherPrice > 0 ? higherPrice : '0.00'
          }
        }, 200)
      },
      /**
       * Retorna a etapa na inscrição
       * Passa os dados preenchidos via props para serem recuperados na etapa
       */
      onPrevious () {
        let data = cloneDeep(this.registration)
        data.eventData.data = cloneDeep(this.data)
        this.$router.push({name: 'registration.store.physical', params: {registration: data}})
      },
      /**
       * Avança uma etapa na inscrição
       * Passa os dados preenchidos via props para serem recuperados na etapa
       */
      onSaveData () {
        let data = cloneDeep(this.registration)
        data.eventData.data = cloneDeep(this.data)
        data.eventData.data.amount = this.currentPrice
        data.eventData.data.knowledge_areas = this.getSelectedsKnowledgeAreas()
        if (data.eventData.data.knowledge_areas.length > 0) {
          data.eventData.data.knowledge_areas = data.eventData.data.knowledge_areas.filter((obj, pos, arr) => {
            return arr.map(mapObj => mapObj['id']).indexOf(obj['id']) === pos
          })
        }
        if (!data.eventData.data.minicurso) {
          data.eventData.data.modalities = this.$refs.modalities.getCheckedKeys()
          data.eventData.data.modalitiesWithEvaluationType = this.$refs.modalities.getCheckedNodes()
        } else {
          data.eventData.data.amount = '0.00'
          data.eventData.data.modalities = []
          data.eventData.data.modalitiesWithEvaluationType = []
        }
        data.eventData.data.literacy = this.dependencies.literacies.filter((item) => {
          return item.id === this.data.literacy_id
        })[0]
        data.eventData.data.institution = this.dependencies.institutions.filter((item) => {
          return item.id === this.data.institution_unit_id
        })[0]
        this.$router.push({name: 'registration.store.confirmation', params: {registration: data}})
      }
    }
  }
</script>

<template>
    <div v-if="!isLoadingData">
        <div class="forms form-registration">
            <div class="buttons-center">
                <el-button type="default"
                           size="large"
                           @click="onPrevious()">
                    <i class="fa fa-arrow-left"></i>
                    <span>Voltar</span>
                </el-button>
            </div>
            <el-form :model="data"
                     label-position="top">
                <h3 class="title-separator">Seus dados</h3>
                <div class="completed-data">
                    <table class="table-confirmation">
                        <tbody>
                        <tr>
                            <td width="50%">
                                <strong>Nome:</strong> {{registration.personalData.data.nome}}
                            </td>
                            <td width="50%">
                                <strong>CPF:</strong> {{registration.physicalData.data.cpf}}
                            </td>
                        </tr>
                        <tr>
                            <td width="50%">
                                <strong>Data Nascimento:</strong> {{registration.physicalData.data.dt_nascimento |
                                dateEnToBr}}
                            </td>
                            <td width="50%">
                                <strong>RG:</strong> {{registration.physicalData.data.rg_numero}}
                            </td>
                        </tr>
                        <tr>
                            <td width="50%">
                                <strong>Celular:</strong> {{registration.physicalData.data.fone_celular}}
                            </td>
                            <td width="50%">
                                <strong>Email:</strong> {{registration.personalData.data.email}}
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <h3 class="title-separator">Informações educacionais</h3>
                <el-row :gutter="20">
                    <el-col :span="24">
                        <el-form-item label="Instituição"
                                      class="is-required"
                                      v-bind:class="{ 'el-form-item--error': $v.data.institution_unit_id.$error }">
                            <el-select v-model="data.institution_unit_id"
                                       clearable
                                       filterable
                                       remote
                                       :remote-method="onSearchInstitution"
                                       :loading="isSearchingInstitution"
                                       @change="onChangeInstitution"
                                       placeholder="Digite o nome da instituição"
                                       empty-text="Nenhum registro encontrado"
                                       class="el-select-full"
                                       @input="$v.data.institution_unit_id.$touch()">
                                <el-option
                                        v-for="item in dependencies.institutions"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                            <validation-message
                                    v-if="$v.data.institution_unit_id.$error"/>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="Escolaridade"
                                      class="is-required"
                                      v-bind:class="{ 'el-form-item--error': $v.data.literacy_id.$error }">
                            <el-select v-model="data.literacy_id"
                                       clearable
                                       filterable
                                       placeholder="Selecione uma Escolaridade"
                                       empty-text="Nenhum registro encontrado"
                                       @change="onChangeLiteracy"
                                       class="el-select-full"
                                       @input="$v.data.literacy_id.$touch()">
                                <el-option
                                        v-for="item in dependencies.literacies"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                            <validation-message v-if="$v.data.literacy_id.$error"/>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="Qualificação/Área de Atuação">
                            <el-input v-model="data.occupation_area"
                                      :max-length="200">
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <div v-if="data.minicurso">
                  <h3 class="title-separator">
                      Desejo me inscrever somente para os Minicursos
                      <el-checkbox v-model="data.minicurso" label="SIM" border size="medium"/>
                  </h3>
                  <el-alert title="Minicursos disponíveis"
                            class="submission-tips"
                            type="warning"
                            v-if="data.minicurso"
                            :closable="false">
                      <ul>
                          <li>Após confirmar a inscrição no Congrega você terá acesso a lista de minicursos</li>
                      </ul>
                  </el-alert>
                </div>
                <div class="has-appraisers event-activities"
                     id="modalities"
                     v-if="!data.minicurso"
                     v-show="dependencies.modalities.length > 0">
                    <h3 class="title-separator">
                        Confirme as modalidades que você pretende participar nos eventos
                    </h3>
                    <el-alert v-if="hasAppraisers"
                              title="Como avaliador você deve selecionar os tipos de avaliação que deseja participar (Web / InLoco)"
                              class="submission-tips"
                              type="warning"
                              :closable="false">
                    </el-alert>
                    <el-row :gutter="20">
                        <el-col :span="18">
                            <el-tree :data="dependencies.modalities"
                                     ref="modalities"
                                     empty-text=""
                                     :default-expand-all="true"
                                     :default-checked-keys="data.modalities"
                                     @check="onCheckModalities"
                                     show-checkbox
                                     node-key="id">
                            <span class="custom-tree-node" slot-scope="{ node, data }">
                                <span>{{ data.title }}</span>
                                <span class="evaluations-type" v-if="node.checked && node.data.key === 'avaliador'">
                                    <el-checkbox-group v-model="node.data.evaluation_types"
                                                       size="mini">
                                      <el-checkbox v-for="item in evaluationTypes"
                                                   :key="item.id"
                                                   v-if="node.data.evaluation_types_available.some(evaluationType => evaluationType === item.id)"
                                                   @change="onCheckEvaluationType"
                                                   :label="item.id">{{item.name}}</el-checkbox>
                                    </el-checkbox-group>
                                </span>
                              </span>
                            </el-tree>
                        </el-col>
                        <el-col :span="6">
                            <div class="current-price">
                                <h2>Valor da Inscrição</h2>
                                <div>R$ {{currentPrice | currencyEnToBr}}</div>
                            </div>
                        </el-col>
                    </el-row>

                    <div v-if="hasAppraisers" class="event-activities">
                        <h3 class="title-separator">Áreas de conhecimento para avaliação</h3>
                        <el-alert
                                title="Como avaliador você pode informar as áreas de conhecimento que se considera apto a avaliar."
                                class="submission-tips"
                                type="warning"
                                :closable="false">
                        </el-alert>
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-form-item label="Grande Área">
                                    <el-select v-model="data.knowledge_area_1_id"
                                               filterable
                                               clearable
                                               multiple
                                               placeholder="Selecione uma opção"
                                               empty-text="Nenhum registro encontrado"
                                               class="el-select-full"
                                               @change="changeKnowledgeArea(data.knowledge_area_1_id, 2)"
                                               @remove-tag="removeKnowledgeArea">
                                        <el-option
                                                v-for="item in dependencies.knowledge_areas_level_1"
                                                :key="item.id"
                                                :label="'(' + item.cnpq_code + ') ' + item.name"
                                                :value="item.id">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="Área">
                                    <el-select v-model="data.knowledge_area_2_id"
                                               :disabled="!data.knowledge_area_1_id.length"
                                               filterable
                                               clearable
                                               multiple
                                               placeholder="Selecione uma opção"
                                               empty-text="Nenhum registro encontrado"
                                               class="el-select-full"
                                               @change="changeKnowledgeArea(data.knowledge_area_2_id, 3)"
                                               @remove-tag="removeKnowledgeArea">
                                        <el-option
                                                v-for="item in dependencies.knowledge_areas_level_2"
                                                :key="item.id"
                                                :label="'(' + item.cnpq_code + ') ' + item.name"
                                                :value="item.id">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-form-item label="Sub-área">
                                    <el-select v-model="data.knowledge_area_3_id"
                                               :disabled="!data.knowledge_area_2_id.length"
                                               filterable
                                               clearable
                                               multiple
                                               placeholder="Selecione uma opção"
                                               empty-text="Nenhum registro encontrado"
                                               class="el-select-full"
                                               @change="changeKnowledgeArea(data.knowledge_area_3_id, 4)"
                                               @remove-tag="removeKnowledgeArea">
                                        <el-option
                                                v-for="item in dependencies.knowledge_areas_level_3"
                                                :key="item.id"
                                                :label="'(' + item.cnpq_code + ') ' + item.name"
                                                :value="item.id">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="Especialidade">
                                    <el-select v-model="data.knowledge_area_4_id"
                                               :disabled="!data.knowledge_area_3_id.length"
                                               filterable
                                               clearable
                                               multiple
                                               placeholder="Selecione uma opção"
                                               empty-text="Nenhum registro encontrado"
                                               class="el-select-full"
                                               @change="changeKnowledgeArea(data.knowledge_area_4_id, 5)"
                                               @remove-tag="removeKnowledgeArea">
                                        <el-option
                                                v-for="item in dependencies.knowledge_areas_level_4"
                                                :key="item.id"
                                                :label="'(' + item.cnpq_code + ') ' + item.name"
                                                :value="item.id">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>
                </div>
                <el-form-item class="buttons-save">
                    <el-button type="primary"
                               size="large"
                               @click="onSaveData"
                               :disabled="isSubmitted || $v.data.$invalid || !hasModalitiesSelected || !hasSomeEvaluationTypeSelected">
                        <i class="fa fa-arrow-right"></i>
                        <span>Salvar e Avançar</span>
                    </el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<style lang="scss">
    .has-appraisers {
        padding-bottom: 140px !important;
    }

    .custom-tree-node {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 14px;
        padding-right: 8px;

        .evaluations-type .el-checkbox__label {
            font-size: 12px;
        }
    }

    #modalities .el-tree-node__content {
        border-bottom: 1px solid #e3e3e3;

        &:last-child {
            margin-bottom: 0;
        }
    }

    .current-price {
        padding: 20px;
        border: 1px solid #e3e3e3;
        border-radius: 8px;
        text-align: center;
        h2 {
            margin: 0;
        }
        div {
            padding-top: 15px;
            font-size: 28px;
            color: #6b6b6b;
        }
    }
</style>
